import {
  Accordion, AccordionDetails, AccordionSummary,
  Grid, Input, NativeSelect, Paper, Typography,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';

import Loading from '../../components/Loading';
import Header from '../../layout/Header';
import Subheader from '../../layout/Subheader';
import api from '../../services/api';
import { findPermission } from '../../services/auth';

import useStyles from './style';

export const MODULO_ID_AGENDAMENTO_REMESSAS = 20102;

const formatDateTimeBr = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime()) || d.getFullYear() < 2000) return '—';
  return d.toLocaleString('pt-BR');
};

export function AgendamentoRemessas () {
  const classes = useStyles();
  const history = useHistory();

  const podeAlterar = !!findPermission(MODULO_ID_AGENDAMENTO_REMESSAS, 'Alterar');
  const podeConsultar = !!findPermission(MODULO_ID_AGENDAMENTO_REMESSAS, 'Consultar');

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [envio1Hora, setEnvio1Hora] = useState('09:00');
  const [envio1Ativo, setEnvio1Ativo] = useState(true);
  const [envio1Proxima, setEnvio1Proxima] = useState(null);
  const [envio1Ultima, setEnvio1Ultima] = useState(null);

  const [envio2Hora, setEnvio2Hora] = useState('16:00');
  const [envio2Ativo, setEnvio2Ativo] = useState(true);
  const [envio2Proxima, setEnvio2Proxima] = useState(null);
  const [envio2Ultima, setEnvio2Ultima] = useState(null);

  const [retornoIntervalo, setRetornoIntervalo] = useState(60);
  const [retornoAtivo, setRetornoAtivo] = useState(true);
  const [retornoProxima, setRetornoProxima] = useState(null);
  const [retornoUltima, setRetornoUltima] = useState(null);

  useEffect(() => {
    if (!podeConsultar) {
      history.replace('/app/home');
      return;
    }
    fetchAgendamento();
  }, []);

  const aplicarResposta = (r) => {
    setEnvio1Hora(r.envio1HoraEspecifica || '09:00');
    setEnvio1Ativo(!!r.envio1Ativo);
    setEnvio1Proxima(r.envio1ProximaExecucao);
    setEnvio1Ultima(r.envio1UltimaExecucao);
    setEnvio2Hora(r.envio2HoraEspecifica || '16:00');
    setEnvio2Ativo(!!r.envio2Ativo);
    setEnvio2Proxima(r.envio2ProximaExecucao);
    setEnvio2Ultima(r.envio2UltimaExecucao);
    setRetornoIntervalo(r.retornoFrequenciaIntervalo || 60);
    setRetornoAtivo(!!r.retornoAtivo);
    setRetornoProxima(r.retornoProximaExecucao);
    setRetornoUltima(r.retornoUltimaExecucao);
  };

  const fetchAgendamento = async () => {
    setLoading(true);
    try {
      const res = await api.get('AgendamentoRemessas');
      if (res?.data?.status === 'Sucesso' && res?.data?.resposta) {
        aplicarResposta(res.data.resposta);
      } else {
        toast.error('Erro ao carregar agendamento.');
      }
    } catch {
      toast.error('Erro ao carregar agendamento.');
    } finally {
      setLoading(false);
    }
  };

  const salvar = async () => {
    if (!podeAlterar) return;
    if (envio1Hora === envio2Hora) {
      toast.warn('Os dois horários de envio não podem ser iguais.');
      return;
    }
    if (!retornoIntervalo || retornoIntervalo < 1 || retornoIntervalo > 1440) {
      toast.warn('Intervalo do retorno deve estar entre 1 e 1440 minutos.');
      return;
    }
    setSaving(true);
    try {
      const res = await api.put('AgendamentoRemessas', {
        envio1HoraEspecifica: envio1Hora,
        envio1Ativo,
        envio2HoraEspecifica: envio2Hora,
        envio2Ativo,
        retornoFrequenciaIntervalo: Number(retornoIntervalo),
        retornoAtivo,
      });
      if (res?.data?.status === 'Sucesso' && res?.data?.resposta) {
        toast.success('Agendamento atualizado.');
        aplicarResposta(res.data.resposta);
      } else {
        const erros = res?.data?.resposta || [];
        if (erros.length > 0) erros.forEach((e) => toast.error(e.message));
        else toast.error('Erro ao salvar.');
      }
    } catch (err) {
      const msg = err?.response?.data?.resposta?.[0]?.message;
      toast.error(msg || 'Erro ao salvar.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={classes.root}>
      <Header />
      <Subheader title="Agendamento de Remessas" back="/app/home" />
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {loading ? (
            <Loading />
          ) : (
            <>
              <Accordion defaultExpanded className={classes.accordionRoot}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                  <Typography className={classes.heading}>Envio — Horário 1</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container spacing={2}>
                    <Grid item xs={3} className={classes.item}>
                      <label className={classes.label}>Horário (HH:mm)</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          type="time"
                          value={envio1Hora}
                          onChange={(e) => setEnvio1Hora(e.target.value)}
                          disabled={!podeAlterar}
                          disableUnderline
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={2} className={classes.item}>
                      <label className={classes.label}>Status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={envio1Ativo ? 1 : 0}
                          onChange={(e) => setEnvio1Ativo(Number(e.target.value) === 1)}
                          disabled={!podeAlterar}
                          style={{ width: '100%' }}
                        >
                          <option value={1}>Ativo</option>
                          <option value={0}>Inativo</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={7} className={classes.item}>
                      <label className={classes.label}>Execuções</label>
                      <div className={classes.infoRow}>Próxima: <strong>{formatDateTimeBr(envio1Proxima)}</strong></div>
                      <div className={classes.infoRow}>Última: {formatDateTimeBr(envio1Ultima)}</div>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded className={classes.accordionRoot}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                  <Typography className={classes.heading}>Envio — Horário 2</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container spacing={2}>
                    <Grid item xs={3} className={classes.item}>
                      <label className={classes.label}>Horário (HH:mm)</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          type="time"
                          value={envio2Hora}
                          onChange={(e) => setEnvio2Hora(e.target.value)}
                          disabled={!podeAlterar}
                          disableUnderline
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={2} className={classes.item}>
                      <label className={classes.label}>Status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={envio2Ativo ? 1 : 0}
                          onChange={(e) => setEnvio2Ativo(Number(e.target.value) === 1)}
                          disabled={!podeAlterar}
                          style={{ width: '100%' }}
                        >
                          <option value={1}>Ativo</option>
                          <option value={0}>Inativo</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={7} className={classes.item}>
                      <label className={classes.label}>Execuções</label>
                      <div className={classes.infoRow}>Próxima: <strong>{formatDateTimeBr(envio2Proxima)}</strong></div>
                      <div className={classes.infoRow}>Última: {formatDateTimeBr(envio2Ultima)}</div>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded className={classes.accordionRoot}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                  <Typography className={classes.heading}>Verificação de Retornos</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container spacing={2}>
                    <Grid item xs={3} className={classes.item}>
                      <label className={classes.label}>Intervalo (minutos)</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          type="number"
                          value={retornoIntervalo}
                          onChange={(e) => setRetornoIntervalo(e.target.value)}
                          inputProps={{ min: 1, max: 1440 }}
                          disabled={!podeAlterar}
                          disableUnderline
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={2} className={classes.item}>
                      <label className={classes.label}>Status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          value={retornoAtivo ? 1 : 0}
                          onChange={(e) => setRetornoAtivo(Number(e.target.value) === 1)}
                          disabled={!podeAlterar}
                          style={{ width: '100%' }}
                        >
                          <option value={1}>Ativo</option>
                          <option value={0}>Inativo</option>
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={7} className={classes.item}>
                      <label className={classes.label}>Execuções</label>
                      <div className={classes.infoRow}>Próxima: <strong>{formatDateTimeBr(retornoProxima)}</strong></div>
                      <div className={classes.infoRow}>Última: {formatDateTimeBr(retornoUltima)}</div>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              {podeAlterar && (
                <div className={classes.registerBtn}>
                  <button
                    type="button"
                    className={classes.button}
                    onClick={salvar}
                    disabled={saving}
                  >
                    {saving ? 'Salvando...' : 'Salvar agendamento'}
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AgendamentoRemessas;
